(function($, undefined) {
    
    'use strict';
    
    
    var init = function (page) {
        var currPage = $(page);      
        
    };

    //save Label is all languages speficied in @langs
    var updateLabelLangs = function(key, value, langs, completeFunction, noload) {
        var a = typeof langs === "string" ? langs.split(",") : langs;
        var successCd = a.length;
        var _complete = function() {
            successCd--;
            if (successCd <= 0) {
                ajaxBlackout(false);
                if (completeFunction) try {completeFunction();} catch (ex) {}
            }
        };
        if (!noload) {
            ajaxBlackout(true);
        }
        for (var i = 0; i < a.length; i++) {
            var lang = a[i];
            updateLabel(key, value, lang, _complete, noload);
        }
    };
        
    var utils = Fw.component.export('utils', {
        init: init,
        updateLabelLangs: updateLabelLangs
    });
    
})(jQuery);